import { requestGet, requestPost, requestPut, requestDelete } from '../request'
import axios from 'axios'
import apiPath from './apiPath'

const api = {
  CreateOutletPrice(payload) {
    return requestPost(apiPath.OUTLET_PRICE.path, payload)
  },

  GetOneOutletPrice(outletPriceID) {
    return requestGet(`${apiPath.OUTLET_PRICE.path}/${outletPriceID}`)
  },

  GetAllOutletPrice(paging, sorting, filtering) {
    return requestGet(apiPath.OUTLET_PRICE.path, {
      page: paging.page,
      size: paging.size,
      sortBy: sorting.byField,
      sortDir: sorting.isDesc ? 'asc' : 'desc',
      f_outletCode: filtering.outletCode,
      f_orderType: filtering.orderType,
      f_priceType: filtering.priceType
    })
  },

  UpdateOutletPrice(outletPriceID, payload) {
    return requestPut(`${apiPath.OUTLET_PRICE.path}/${outletPriceID}`, payload)
  },

  DeleteOutletPrice(outletPriceID) {
    return requestDelete(`${apiPath.OUTLET_PRICE.path}/${outletPriceID}`)
  },

  GetOutletPriceConfig() {
    return axios({
      url: `${process.env.VUE_APP_QRAVED_APP_URL}/${
        apiPath.ORDERING_ORDER_BO_GLOBAL_CONFIG.path
      }`,
      method: 'get'
    })
  }
}

export default api
